import React, { useState } from 'react';
import { forgotPassword } from '../../../../api/authApi';
import { useProfileSheet } from '../../../../contexts/ProfileSheetContext';
import SheetField from '../shared/SheetField';
import SheetMessage from '../shared/SheetMessage';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ForgotPasswordView: React.FC = () => {
  const { setView } = useProfileSheet();
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) {
      setError('Enter a valid email address');
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong');
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <SheetMessage kind="ok">
          Check your email — if an account exists for {email.trim()}, a reset
          link is on its way.
        </SheetMessage>
        <div className="tend-links-row">
          <button type="button" className="tend-link" onClick={() => setView('login')}>
            Back to sign in
          </button>
          <button
            type="button"
            className="tend-link"
            onClick={() => {
              setSent(false);
              setEmail('');
            }}
          >
            Try another email
          </button>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <p style={{ color: 'var(--text-2)', fontSize: 13.5, lineHeight: 1.55, margin: 0 }}>
        Enter your email and we&apos;ll send you a link to reset your password.
      </p>
      {error && <SheetMessage kind="err">{error}</SheetMessage>}
      <SheetField
        label="Email"
        value={email}
        onChange={setEmail}
        type="email"
        name="email"
        autoComplete="email"
        disabled={submitting}
        autoFocus
      />
      <button
        type="submit"
        className="tend-btn tend-btn--cta tend-btn--block"
        disabled={submitting}
        style={{ marginTop: 4 }}
      >
        {submitting ? 'Sending…' : 'Send Reset Link'}
      </button>
      <div className="tend-links-row">
        <button type="button" className="tend-link" onClick={() => setView('login')}>
          Back to sign in
        </button>
      </div>
    </form>
  );
};

export default ForgotPasswordView;
